import { render } from "./subsUser.vue?vue&type=template&id=e36f8220"
import script from "./subsUser.vue?vue&type=script&lang=js"
export * from "./subsUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__